import { data } from "./planner.data";

var table = (function() {
    const tblFixturesThead = document.getElementById('tbl-fixtures-thead');
    const tblFixturesTbody = document.getElementById('tbl-fixtures-tbody');
    const tblFixturesTfoot = document.getElementById('tbl-fixtures-tfoot');
    
    const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

    var table = null;

    function bindEvents()
    {        
        document.addEventListener("newData", function(e){            
            reloadPlanner();
        });
    }

    function resetTableHeader(gameweekDates) {
        console.log("RESET HEADER", gameweekDates);
        var toFrom = slider.noUiSlider.get();

        const tblFixturesThead = document.getElementById('tbl-fixtures-thead');
        tblFixturesThead.innerHTML = '';

        let headerRow = '<tr><th>Team</th>';
        for (let gw = toFrom[0]; gw <= toFrom[1]; gw++) {
            var date = gameweekDates.find(d => d.number === gw).dateStart;
            var jsDate = new Date(date);
            var month = monthNames[jsDate.getMonth()];
            var day = jsDate.getDate();

            headerRow += `<th>GW${gw}<br/>${day} ${month}</th>`;
        }
        headerRow += '<th>Avg<br/>Difficulty</th><th>Easy<br/>Count</th></tr>';

        tblFixturesThead.innerHTML = headerRow;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function reloadPlanner()
    {
        console.log("test");
        if (table !== null)
        {
            table.destroy();
           //table.clear();
            tblFixturesThead.innerHTML = '';
            tblFixturesTbody.innerHTML = '';
            tblFixturesTfoot.innerHTML = '';
        }

        var toFrom = slider.noUiSlider.get();
                
        resetTableHeader(data.getValues().gameweekDates);

        data.getValues().rows.forEach(element => {
            var row = `<tr><td>${element.teamName}</td>`;
            var totalDifficulty = 0;
            var easyCount = 0;

            console.log("ROW", element);

            var fixtureCount = 0;

            data.getValues().gameweekDates.forEach(gwd => {                
                if (gwd.number < toFrom[0] || gwd.number > toFrom[1]) {
                    return;
                }

                var gwDateEndPlusOne = addDays(new Date(new Date(data.getValues().gameweekDates.find(d => d.number === gwd.number).dateEnd).toDateString()), 1).getTime();

                var gwList = element.gameweeks.filter(g => g.number == gwd.number);

                if (gwList.length == 0) {
                    row += `<td data-sort="${0}" class="difficulty-${0}${currentDate >= gwDateEndPlusOne ? " played" : ""} blankgw">-</td>`;
                }
                else if (gwList.length == 1) {
                    var gw = gwList[0];
                    
                    var currentDate = new Date().getTime();

                    row += `<td data-sort="${gw.difficulty}" class="difficulty-${gw.difficulty}${currentDate >= gwDateEndPlusOne ? " played" : ""}">`;

                    var gwDefPicks = data.getValues().picks.filter(pick => pick.gameweek == gw.number && pick.teamName == element.teamName && pick.position < 3);

                    gwDefPicks.forEach(element => {
                        if (element.order < 12)
                        {
                            row += '<div class="gwpick" title="' + element.name + '"><img src="./../img/shield.svg"></div>';
                        }
                    });

                    var gwAtkPicks = data.getValues().picks.filter(pick => pick.gameweek == gw.number && pick.teamName == element.teamName && pick.position >= 3);

                    gwAtkPicks.forEach(element => {
                        if (element.order < 12)
                        {
                            row += '<div class="gwpick" title="' + element.name + '"><img src="./../img/sword.svg"></div>';
                        }
                    });
                    
                    if (gw.score != "-")
                    {
                        row += `<div class="gw-score score-${gw.result}">${gw.score}</div>`;
                    }

                    row += `<div class="opposition-name">${gw.oppositionName} (${gw.isHome ? "H" : "A"})</div>`
                    row += `</td>`;
                    totalDifficulty += gw.difficulty;
                    easyCount += gw.difficulty < 3 ? 1 : 0;
                    fixtureCount += 1;
                }
                else
                {
                    var difficulty = gwList.sort(function(a, b) {
                            return a.difficulty - b.difficulty;
                            })[0].difficulty;

                    row += `<td data-sort="${difficulty}" class="${currentDate >= gwDateEndPlusOne ? " played" : ""}">`;

                        var gwDefPicks = data.getValues().picks.filter(pick => pick.gameweek == gwd.number && pick.teamName == element.teamName && pick.position < 3);

                        gwDefPicks.forEach(element => {
                            if (element.order < 12)
                            {
                                row += '<div class="gwpick" title="' + element.name + '"><img src="./../img/shield.svg"></div>';
                            }
                        });

                        var gwAtkPicks = data.getValues().picks.filter(pick => pick.gameweek == gwd.number && pick.teamName == element.teamName && pick.position >= 3);

                        gwAtkPicks.forEach(element => {
                            if (element.order < 12)
                            {
                                row += '<div class="gwpick" title="' + element.name + '"><img src="./../img/sword.svg"></div>';
                            }
                        });

                        row += `<div class="gw-scores">`;

                        gwList.sort(function(a, b) { 
                            return new Date(a.kickOffTime) - new Date(b.kickOffTime);
                        }).forEach(gw => {
                            if (gw.score != "-")
                            {
                                row += `<div class="gw-score score-dgw score-${gw.result}">${gw.score}</div>`;
                            }
                        });

                        row += `</div>`;

                        var counter = 1;

                        gwList.sort(function(a, b) { 
                            return new Date(a.kickOffTime) - new Date(b.kickOffTime);
                        }).forEach(gw => {
                            console.log("GW222", gw);
                            row += `<div class="opposition-name dgw dgw-${counter} difficulty-${gw.difficulty}">${gw.oppositionName} (${gw.isHome ? "H" : "A"})</div>`                        
                            
                            totalDifficulty += gw.difficulty;
                            easyCount += gw.difficulty < 3 ? 1 : 0;
                            fixtureCount += 1;
                            counter++;
                        });

                        row += `</td>`;
                }
            });

            row += `<td>${(totalDifficulty / fixtureCount).toFixed(2)}</td>`;
            row += `<td>${easyCount}</td>`;

            row += `</tr>`;

            tblFixturesTbody.innerHTML += row;
        });

        var benchRow = `<tr class="no-sort"><td></td>`;
        
        var toFrom = slider.noUiSlider.get();

        var gwPicks = [];

        var currentBank = data.getValues().gameweekHistories.length > 0 ? data.getValues().gameweekHistories[data.getValues().gameweekHistories.length - 1].bank : 100;

        for (let gameweek = toFrom[0]; gameweek <= toFrom[1]; gameweek++) {
            var gameweekPicks = data.getValues().picks.filter(pick => pick.gameweek == gameweek)[0];
            var isPlanned = gameweekPicks ? gameweekPicks.isPlanned : false;
            var gameweekHistory = data.getValues().gameweekHistories.find(gw => gw.gameweekId == gameweek);

            benchRow += `<td class="bench-gw-${gameweek} ${isPlanned ? "" : "completed-gw"}">`;
            
            var chip = data.getValues().gameweekChips.find(x => x.gameweekId == gameweek);
            var plannedChip = data.getValues().plannedChips.find(x => x.event == gameweek);

            var chipUsed = (chip == null) ? (plannedChip == null ? "" : plannedChip.name) : data.getValues().chips.find(x => x.id == chip.chipId).name;
            
            var previousGWPicks = gameweek == 1 ? [] : data.getValues().picks.filter(pick => pick.gameweek == gameweek - 1);

            var previousPlannedChip = data.getValues().plannedChips.find(x => x.event == gameweek - 1);
            var previousChip = data.getValues().gameweekChips.find(x => x.gameweekId == gameweek - 1);
            var previousChipUsed = (previousChip == null) ? (previousPlannedChip == null ? "" : previousPlannedChip.name) : data.getValues().chips.find(x => x.id == previousChip.chipId).name;

            if (previousChipUsed == "freehit")
            {
                previousGWPicks = gameweek <= 2 ? [] : data.getValues().picks.filter(pick => pick.gameweek == gameweek - 2); // wont work when 2 freehits used back to back
            }

            var gk = "";
            var def = "";
            var mid = "";
            var fwd = "";
            var benchgk = "";
            var bench = "";

            gwPicks = data.getValues().picks.filter(pick => pick.gameweek == gameweek);

            console.log("GW PICKS " + gameweek, gwPicks);

            gwPicks.filter(x => x.position == 1 && x.order < 12).forEach(pick => {
                gk += getPickMarkup(pick, gameweek, isPlanned);
            });

            gwPicks.filter(x => x.position == 2 && x.order < 12).sort((a, b) => a.order - b.order).forEach(pick => {
                def += getPickMarkup(pick, gameweek, isPlanned);
            });

            gwPicks.filter(x => x.position == 3 && x.order < 12).sort((a, b) => a.order - b.order).forEach(pick => {
                mid += getPickMarkup(pick, gameweek, isPlanned);
            });

            gwPicks.filter(x => x.position == 4 && x.order < 12).sort((a, b) => a.order - b.order).forEach(pick => {
                fwd += getPickMarkup(pick, gameweek, isPlanned);
            });

            gwPicks.filter(x => x.position == 1 && x.order >= 12).forEach(pick => {
                benchgk += getPickMarkup(pick, gameweek, isPlanned);
            });

            gwPicks.filter(x => x.position != 1 && x.order >= 12).sort((a, b) => a.order - b.order).forEach(pick => {
                bench += getPickMarkup(pick, gameweek, isPlanned);
            });

            benchRow += "<div class=\"selected-players\">" + gk + "<br/>" + def + "<br/>" + mid + "<br/>" + fwd + "<br/>" + benchgk + bench + `</div>`;
                        
            benchRow += "<div><button " + (!isPlanned ? "disabled " : "")  + " class=\"gw-chip btn btn-sm btn" + (chipUsed == "" ? "" : " chip-used") + "\" data-gameweek=\"" + gameweek + "\">" + (chipUsed == "" ? "No Chip" : chipUsed)   + "</button>";
            
            // if (isPlanned)
            // {
            //     benchRow += "<button class=\"btn-edit-gameweek btn btn-sm btn\" data-gameweek=\"" + gameweek + "\">Edit</button>";
            // }
            
            benchRow += "</div>";
            benchRow += `<div class="gameweek-stats">`;

            if (isPlanned)
            {
                benchRow += `<img src="./img/bank.svg" alt="Bank">£${(currentBank / 10).toFixed(1)}`;
            }
            else 
            {
                benchRow += `<img src="./img/score.svg" alt="Points">${gameweekHistory == null ? '-' : gameweekHistory.points}pts`;
            }

            if (gameweek > 1)
            {
                benchRow += `<img src="./img/transfer.svg" alt="Transfers">3/2`;
            }

            benchRow += `</div>`;
                        
            // output transfers

            if (gameweek > 1 && chipUsed != "freehit")
            {
                var gwPicks = data.getValues().picks.filter(pick => pick.gameweek == gameweek);

                var previousGKs = previousGWPicks.filter(x => x.position == 1).map(x => x.name);
                var currentGKs = gwPicks.filter(x => x.position == 1).map(x => x.name);
                var gkOld = previousGKs.filter(x => !currentGKs.includes(x));
                var gkNew = currentGKs.filter(x => !previousGKs.includes(x));

                var previousDefs = previousGWPicks.filter(x => x.position == 2).map(x => x.name);
                var currentDefs = gwPicks.filter(x => x.position == 2).map(x => x.name);
                var defOld = previousDefs.filter(x => !currentDefs.includes(x));
                var defNew = currentDefs.filter(x => !previousDefs.includes(x));

                var previousMids = previousGWPicks.filter(x => x.position == 3).map(x => x.name);
                var currentMids = gwPicks.filter(x => x.position == 3).map(x => x.name);
                var midOld = previousMids.filter(x => !currentMids.includes(x));
                var midNew = currentMids.filter(x => !previousMids.includes(x));

                var previousFwds = previousGWPicks.filter(x => x.position == 4).map(x => x.name);
                var currentFwds = gwPicks.filter(x => x.position == 4).map(x => x.name);
                var fwdOld = previousFwds.filter(x => !currentFwds.includes(x));
                var fwdNew = currentFwds.filter(x => !previousFwds.includes(x));


                benchRow += "<br/>";
                benchRow += `<div class="transfer-list">`;

                if (gkOld !== undefined)
                {
                    for (let i = 0; i < Object.keys(gkOld).length; i++) {
                        benchRow += `<div class="transfer"><div>${gkOld[i]}</div><div><img src="./img/arrow.svg" alt="Transfer"></div><div>${gkNew[i]}</div></div>`;
                    }
                }

                if (defOld !== undefined)
                {
                    for (let i = 0; i < Object.keys(defOld).length; i++) {
                        benchRow += `<div class="transfer"><div>${defOld[i]}</div><div><img src="./img/arrow.svg" alt="Transfer"></div><div>${defNew[i]}</div></div>`;
                    }
                }

                if (midOld !== undefined)
                {
                    for (let i = 0; i < Object.keys(midOld).length; i++) {
                        benchRow += `<div class="transfer"><div>${midOld[i]}</div><div><img src="./img/arrow.svg" alt="Transfer"></div><div>${midNew[i]}</div></div>`;
                    }
                }

                if (fwdOld !== undefined)
                {
                    for (let i = 0; i < Object.keys(fwdOld).length; i++) {
                        benchRow += `<div class="transfer"><div>${fwdOld[i]}</div><div><img src="./img/arrow.svg" alt="Transfer"></div><div>${fwdNew[i]}</div></div>`;
                    }
                }

                benchRow += `</div>`;
            }
            else if (chipUsed == "freehit")
            {
                benchRow += `<br/><div>(Free Hit)</div>`;
            }

            benchRow += `</td>`;
        }

        benchRow += `<td></td><td></td></tr>`;

        tblFixturesTfoot.innerHTML += benchRow;
        

       // if (table == null)
       // {
            table = new DataTable('#tbl-fixtures', {
                fixedColumns: true,
                paging: false,
                searching: false,
                info: false,
                // scrollCollapse: true,
                scrollX: true
            });         
        // }
        // else {
        //     $('#tbl-fixtures').DataTable().ajax.reload();
        // }
    }

    function getPickMarkup(pick, gameweek, isPlanned)
    {
        var oppositionList = data.getValues().rows.filter(r => r.teamName == pick.teamName)[0].gameweeks.filter(gw => gw.number == gameweek);

        var difficulty = 0;
        var oppositionName = "-";
        var isHome = true;

        var markup = "";

        if (oppositionList.length == 1)
        {
            difficulty = oppositionList[0].difficulty;
            oppositionName = oppositionList[0].oppositionName;  
            isHome = oppositionList[0].isHome;          
        }
        else if (oppositionList.length > 1)
        {
            difficulty = oppositionList.sort(function(a, b) {
                return a.difficulty - b.difficulty;
                })[0].difficulty;         

            oppositionName = oppositionList.map(gw => gw.oppositionName).join(", ");
        }

        var markup = `<div class="sp-row${isPlanned ? " edit-link" : ""}" data-gameweek="${gameweek}" data-playerId=${pick.playerId}><div class="sp-cell">${getPositionLetter(pick.position)}</div><div class="sp-cell">${pick.teamNameShort}</div><div class="sp-cell">${pick.name}${pick.isCaptain ? ' <span class="captain"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true" class="_1gt0wqv5 _1gt0wqv4"><circle cx="12" cy="12" r="12" aria-hidden="true"></circle><path d="M15.0769667,14.370341 C14.4472145,15.2780796 13.4066319,15.8124328 12.3019667,15.795341 C10.4380057,15.795341 8.92696674,14.284302 8.92696674,12.420341 C8.92696674,10.55638 10.4380057,9.045341 12.3019667,9.045341 C13.3988206,9.06061696 14.42546,9.58781014 15.0769667,10.470341 L17.2519667,8.295341 C15.3643505,6.02401882 12.1615491,5.35094208 9.51934028,6.67031017 C6.87713147,7.98967826 5.49079334,10.954309 6.17225952,13.8279136 C6.8537257,16.7015182 9.42367333,18.7279285 12.3769667,18.720341 C14.2708124,18.7262708 16.0646133,17.8707658 17.2519667,16.395341 L15.0769667,14.370341 Z" fill="currentColor" aria-hidden="true"></path></svg></span>' : ''}${pick.isViceCaptain ? ' <span class="vice-captain"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" focusable="false" aria-hidden="true" class="_1gt0wqv5 _1gt0wqv4"><circle cx="12" cy="12" r="12" aria-hidden="true"></circle><polygon points="13.5 .375 8.925 12.375 4.65 12.375 0 .375 3.15 .375 6.75 10.05 10.35 .375" transform="translate(5.25 6)" fill="currentColor" aria-hidden="true"></polygon></svg></span>' : ''}</div>`;
        
        if (!isPlanned)
        {
            markup += `<div class="sp-cell pick-points">${pick.points}</div>`;
        }
        else {
            console.log("PLANNED PICK", pick.value);
            var cost = "£" + (parseInt(pick.value) / 10).toFixed(1);

            markup += `<div class="sp-cell pick-price">${cost}</div>`;
        }

        markup += `<div class="sp-cell difficulty-container">`;
        
        console.log("oppo",oppositionList);
        oppositionList.sort(function(a, b) { 
                            return new Date(a.kickOffTime) - new Date(b.kickOffTime)}).forEach(e => {
            markup += `<div class="difficulty ${oppositionList.length > 1 ? "dgw " : ""} difficulty-${e.difficulty}${e.isHome ? "" : " away"}">${e.oppositionName}</div>`
        });
        
        markup += `</div></div>`;
        return markup;
    }
    
    function getPositionLetter(position) {
        switch(position) {
            case 1: return "GK";
            case 2: return "DEF";
            case 3: return "MID";
            case 4: return "FWD";
        }
    }
    
    function init() {
        bindEvents();
    }

    return {
        init: init
    };
})();

export { table }